import { defaultPm2PrintChunkClassName } from '@provider/print';
import { ScrambledCard } from './comp.scrambled.js';
import { jsx } from 'react/jsx-runtime';

const printGeogebraComponentPaper = node => {
  return [{
    containerClassName: defaultPm2PrintChunkClassName,
    content: /*#__PURE__*/jsx(ScrambledCard, {
      title: node.component.envelope.Title
    })
  }];
};
const geogebraComponentPaperPrinters = {
  "component-framework.geogebra": printGeogebraComponentPaper
};

export { geogebraComponentPaperPrinters };
//# sourceMappingURL=printer.to-paper.js.map
